<template>
  <div class="projet-part">
    <h2 id="financements">
      {{
        projetAnnuel.typeDossier == "DOSSIER_INSCRIPTION"
          ? $t("projetPage.infoAdministratives.financement.titre-inscription")
          : $t("projetPage.infoAdministratives.financement.titre")
      }}
    </h2>

    <fieldset>
      <legend>{{ $t("projetPage.infoAdministratives.financement.sous-titre-1") }}</legend>
      <b-message type="is-info">
        <p>
          {{ $t("projetPage.infoAdministratives.financement.info-message-1") }}
          <a :href="$t('projet.doc.financement-inscription-url')" target="_blank">{{
            $t("projet.doc.financement-inscription-url")
          }}</a>
        </p>
      </b-message>
      <div style="margin-top: 5px; margin-bottom: 5px">
        <div style="margin-top: 5px; margin-bottom: 5px">
          <b-button
            v-if="!readonly"
            type="is-primary is-rounded"
            tag="a"
            target="_blank"
            href="https://ame.ofb.fr/doku.php?id=justificatifs"
            style="margin-top: 5px; margin-bottom: 5px"
          >
            {{ $t("projetPage.infoAdministratives.financement.demande") }}
          </b-button>
          <b-button
            v-else
            type="is-primary is-rounded"
            tag="button"
            disabled
            style="margin-top: 5px; margin-bottom: 5px"
          >
            {{ $t("projetPage.infoAdministratives.financement.demande") }}
          </b-button>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>{{ $t("projetPage.infoAdministratives.financement.sous-titre-2") }}</legend>
      <div class="inputNotice mb-2">
        {{ $t("projetPage.infoAdministratives.financement.info-message-2") }}
        <a :href="$t('projet.doc.financement-url')" target="_blank">{{
          $t("projet.doc.financement-label")
        }}</a>
      </div>
      <div class="cards">
        <FinancementCard
          v-if="!readonly"
          :projet-annuel="projetAnnuel"
          :can-delete="false"
          @add="added"
        />

        <div
          v-for="financement in projetAnnuel.financements.slice().reverse()"
          :key="financement.id"
        >
          <FinancementCard
            v-if="isValid(financement)"
            :validation-activated="validationActivated"
            :show-validation-errors="showValidationErrors"
            :financement="financement"
            :projet-annuel="projetAnnuel"
            :can-delete="!readonly"
            @delete="deleted"
          />
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script lang="ts">
import { FinancementDTO, ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent } from "vue"
import { FinancementService } from "@/services/rest/financement/FinancementService"
import FinancementCard from "@/views/project/FinancementCard.vue"
import { BButton, BMessage } from "buefy"

export default defineComponent({
  name: "ProjetFinancementView",
  components: {
    FinancementCard,
    BButton,
    BMessage,
  },
  props: {
    projetAnnuel: {
      type: Object as () => ProjetAnnuelDTO,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: false,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["projet-annuel-updated", "dirtify-project", "trigger-validation"],
  data() {
    return {
      financementService: FinancementService.INSTANCE,
    }
  },
  methods: {
    added(financement: FinancementDTO): void {
      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        financements: [...this.projetAnnuel.financements, financement],
      }
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
      this.$emit("dirtify-project")
      // Déclencher la validation pour mettre à jour le menu contextuel
      this.$nextTick(() => this.$emit("trigger-validation"))
    },

    deleted(financement: FinancementDTO): void {
      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        financements: this.projetAnnuel.financements.filter(function (value) {
          return value !== financement
        }),
      }
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
      this.$emit("dirtify-project")
      // Déclencher la validation pour mettre à jour le menu contextuel
      this.$nextTick(() => this.$emit("trigger-validation"))
    },

    isValid(financement: FinancementDTO): boolean {
      return this.financementService.isValid(this.projetAnnuel, financement.debut, financement.fin)
    },
  },
})
</script>

<style scoped lang="scss">
.cards {
  display: flex;
  flex-wrap: wrap;
  height: auto;
}
</style>
